<template>
    <div class="row">

        <div class="col-lg-4 col-6">
            <div class="small-box bg-info">
                <div class="inner">
                    <h3>Dashboard</h3>
                </div>
                <div class="icon">
                    <i class="fa fa-dashboard"></i>
                </div>
                <a href="../Home/Index" class="small-box-footer">More<i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>

        <div class="col-lg-4 col-6">
            <div class="small-box bg-warning">
                <div class="inner">
                    <h3>Profile</h3>
                </div>
                <div class="icon">
                    <i class="fa fa-user"></i>
                </div>
                <a href="../Portal/Profile" class="small-box-footer">More<i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>

        <div class="col-lg-4 col-6">
            <div class="small-box bg-olive">
                <div class="inner">
                    <h3>Time Table</h3>
                </div>
                <div class="icon">
                    <i class="fa fa-calendar"></i>
                </div>
                <a href="../Portal/TimeTable" class="small-box-footer">More<i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>

        <div class="col-lg-4 col-6">
            <div class="small-box bg-success">
                <div class="inner">
                    <h3>{{attendance}}%</h3>
                    <p>Attendance</p>
                </div>
                <div class="icon">
                    <i class="far fa-calendar-check"></i>
                </div>
                <a href="../Portal/Attendance" class="small-box-footer">More<i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>

        <!--<div class="col-lg-4 col-6">
            <div class="small-box bg-maroon">
                <div class="inner">
                    <h3>Assignments</h3>
                </div>
                <div class="icon">
                    <i class="fa fa-tasks"></i>
                </div>
                <a href="../Portal/Assignment" class="small-box-footer">More<i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>-->

        <div class="col-lg-4 col-6">
            <div class="small-box bg-purple">
                <div class="inner">
                    <h3>{{result}}%</h3>
                    <p>Results</p>
                </div>
                <div class="icon">
                    <i class="fa fa-list-alt"></i>
                </div>
                <a href="../Portal/Result" class="small-box-footer">More<i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>

        <div class="col-lg-4 col-6">

            <div class="small-box bg-danger">
                <div class="inner">
                    <h3>{{PendingFee.toLocaleString()}}</h3>
                    <p>Pending Fee</p>
                </div>
                <div class="icon">
                    <i class="fa fa-dollar"></i>
                </div>
                <a href="../Portal/Fee" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
            </div>
        </div>

    </div>
</template>
<script>import axios from 'axios';
    export default {
        name: 'dashboard',
        data() {
            return {
                attendance: 0,
                result: 0,
                PendingFee: 0,
            }


        },
        created() {
            this.pageloadHomePage();
        },
        methods: {
            pageloadHomePage() {
                startReq();
                var vm = this;
                axios.post('/api/PortalApi/pageLoadHomePage')
                    .then(function (response) {
                        vm.attendance = response.data.totalPresent != 0 ? Math.round((response.data.totalPresent / response.data.totalLectures) * 100) : 0;
                        vm.result = Math.round(response.data.ExamPercentage);
                        vm.PendingFee = response.data.PendingFee;
                        endReq();
                    })
            }
        }
    }</script>

<style>
    .btn-action {
        margin-bottom: 4px;
    }

    .crs-title {
        border-bottom: 1px dashed black;
        padding-bottom: 10px;
    }

    .small-box h3 {
        font-size: 1.7rem;
        font-weight: 600;
        margin: 10px 0 10px 0;
        padding: 0;
        white-space: nowrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/homePage.vue